import Application from '@ember/application';
import compatModules from '@embroider/virtual/compat-modules';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from './config/environment';
import 'ember-basic-dropdown/styles';
// CSS imports - imported here instead of @import in CSS for proper Vite bundling
// Tailwind must be first - processed by @tailwindcss/vite
import './styles/tailwind.css';
import './styles/fonts.css';
import './styles/animations.css';
import './styles/shooting-stars.css';
import './styles/components/space-button.css';
import './styles/components/space-card.css';
import './styles/components/space-badge.css';
import './styles/components/space-input.css';
import './styles/components/typewriter-neon.css';
import './styles/components/tech-icons.css';
import './styles/components/service-icons.css';
import './styles/components/mobile-navbar.css';
import './styles/components/hamburger-menu.css';
import './styles/components/navbar.css';
import './styles/components/image-lightbox.css';
import './styles/sections/success-cases.css';
import './styles/sections/team-explorer.css';
import './styles/components/language-loading-overlay.css';
import './styles/components/debug-panel.css';
import './styles/components/ember-services.css';
import './styles/components/lazy-mars-canvas.css';
import './styles/app.css';
import '@warp-drive/ember/install';

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver.withModules(compatModules);
}

loadInitializers(App, config.modulePrefix, compatModules);
